(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57723],{

/***/ 76521:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/b2b/[category]",
      function () {
        return __webpack_require__(95294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SeveralBrandsCategoryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73191);
/* harmony import */ var _components_severalbrands_businessPhoneSystemsComponents__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68126);
/* harmony import */ var _components_severalbrands_fleetManagementComponents__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22214);
/* harmony import */ var _components_severalbrands_crmComponents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60212);
/* harmony import */ var _components_severalbrands_creditCardProcessingComponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96491);
/* harmony import */ var _components_severalbrands_forkliftsComponents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55682);
/* harmony import */ var _components_severalbrands_pointOfSaleComponents__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35302);
/* harmony import */ var _components_severalbrands_payrollComponents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41079);
/* harmony import */ var _components_severalbrands_peoComponents__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77691);
/* harmony import */ var _components_severalbrands_medicalSoftwareComponents__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34720);
/* harmony import */ var _components_severalbrands_digitalCopierComponents__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77198);
/* harmony import */ var _components_severalbrands_wideFormatPrintersComponents__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(39860);














var __N_SSP = true;
function SeveralBrandsCategoryPage() {
    const { domain , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    let content;
    switch(category?.slug){
        case "sb-fleet-management":
        case "fleet-management":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_fleetManagementComponents__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
            break;
        case "sb-business-phone-systems":
        case "business-phone-systems":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_businessPhoneSystemsComponents__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
            break;
        case "sb-crm":
        case "crm":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_crmComponents__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
            break;
        case "sb-credit-card-processing":
        case "credit-card-processing":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_creditCardProcessingComponents__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
            break;
        case "sb-forklifts":
        case "forklifts":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_forkliftsComponents__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
            break;
        case "sb-point-of-sale":
        case "point-of-sale":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_pointOfSaleComponents__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
            break;
        case "sb-payroll":
        case "payroll":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_payrollComponents__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
            break;
        case "sb-peo-employee-leasing":
        case "peo":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_peoComponents__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {});
            break;
        case "sb-medical-software":
        case "medical-software":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_medicalSoftwareComponents__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {});
            break;
        case "sb-digital-copier":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_digitalCopierComponents__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {});
            break;
        case "sb-wide-format-printers":
            content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_wideFormatPrintersComponents__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {});
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_severalBrandsWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        domainInfo: domain,
        children: content
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,83831,81711,73921,41035,49774,92888,40179], function() { return __webpack_exec__(76521); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);